// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyAIi5W6TMZQrBNQvyjbD1bw-ycMOJegjrE",
    authDomain: "othercooked.firebaseapp.com",
    databaseURL: "https://othercooked.firebaseio.com",
    projectId: "othercooked",
    storageBucket: "othercooked.appspot.com",
    messagingSenderId: "12727556867",
    appId: "1:12727556867:web:61af7a8012ec9af79e2736",
    measurementId: "G-T07NB6J9DZ"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
